class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'recently_viewed_products';
    this.sectionId = this.dataset.sectionId;
    this.currentProductId = this.dataset.currentProduct || String(window.ShopifyAnalytics?.meta?.product?.id || '');

    this.saveCurrentProduct();
    this.loadRecentlyViewed();
  }

  saveCurrentProduct() {
    if (!this.currentProductId) return;
    let products = this.getProducts();
    products = products.filter(id => id !== this.currentProductId);
    products.unshift(this.currentProductId);
    products = products.slice(0, 20);
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(products));
    } catch(e) {}
  }

  getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch(e) {
      return [];
    }
  }

  async loadRecentlyViewed() {
    let products = this.getProducts();
    products = products.filter(id => id !== this.currentProductId).slice(0, 8);

    if (products.length === 0) {
      this.style.display = 'none';
      return;
    }

    const query = products.map(id => `id:${id}`).join(' OR ');
    const url = `/search?q=${encodeURIComponent(query)}&type=product&section_id=${this.sectionId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`${response.status}`);

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const newSection = html.querySelector(`#recently-viewed-${this.sectionId}`);
      if (newSection?.innerHTML?.trim()) {
        this.innerHTML = newSection.innerHTML;
      } else {
        this.style.display = 'none';
      }
    } catch(e) {
      console.error('Recently viewed error:', e.message);
      this.style.display = 'none';
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}